import React, { useEffect, useState } from 'react';
import { usePage } from '../PageContext';
import GlimpsesBg from '../assets/images/glimpses-bg.png';
import Lightbox from "yet-another-react-lightbox";
import Counter from "yet-another-react-lightbox/plugins/counter";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/counter.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import { Row,Col,Card,Placeholder } from 'react-bootstrap';
const GlimpsesDetails = ({htaccess}) => 
{
    const { currentPage } = usePage();
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[Glimpse,setGlimpse]=useState([]);
    const[isLoading, setLoading] = useState(true);
    useEffect(()=>
    {
        const GlimpsesDetails = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"glimpses/details/"+htaccess);
                const result = await response.json();
                if( result.length > 0 )
                {
                    Promise.all(
                        result.map(
                            e => fetch(global.config.API_URL + "upload/details/0/" + e.sg_id + "/siteGlimpses")
                                .then(up => up.json())
                        )
                    ).then(ups => {
                        ups.forEach((el, i) => {
                            result[i].siteGlimpses = (el.length > 0) ? el : [];
                            result[i].countGlimpses = el.length;
                        });
                        setGlimpse(result);
                        currentPage(result[0]);
                        setLoading(false);
                    }).catch(error => {
                        console.error('GlimpsesDetails Photos :', error);
                        setLoading(false);
                    });
                }
                else
                {
                    setGlimpse([]);
                    setLoading(false);            
                }
                if( global.config.IsPrint === true ) { console.info('GlimpsesDetails : Result',result); }
            }
            catch (error) 
            {
                console.error('GlimpsesDetails : Error', error.message);
            }
        };
        GlimpsesDetails();
        // eslint-disable-next-line
    },[htaccess])
    return (
        <React.Fragment>
        {isLoading ? (
            <Card className='bg-secondary-subtle text-center' style={{backgroundImage:"url("+GlimpsesBg+")"}}>
                <Card.Header className='text-center fs-4' data-aos="flip-up" data-aos-duration="1500"><Placeholder xs={10} /></Card.Header>
                <Card.Body>
                    <Row className='row-cols-1 row-cols-sm-2 row-cols-md-3 g-3 '>
                        {[...Array(12)].map((_,index)=>(
                        <Col key={index}>
                            <Card className='bg-secondary-subtle border border-3 text-center'>
                                <Placeholder xs={12} style={{height:"200px"}} className="img-fluid" />
                            </Card>
                        </Col>
                        ))}
                    </Row>
                </Card.Body>
            </Card>
        ) : (
            <React.Fragment>
            {Glimpse.map((sg,index)=>(
            <Card className='bg-secondary-subtle text-center' key={index} style={{backgroundImage:"url("+GlimpsesBg+")"}}>
                <Card.Header className='text-center fs-3 text-uppercase' data-aos="flip-up" data-aos-duration="1500">
                    {appLanguage === 'hi' ? (sg.sg_display_en === "1" ? sg.sg_name_hi || '' : sg.sg_name_hi || sg.sg_name) : sg.sg_name} ({sg.countGlimpses} {appLanguage === 'hi' ? 'तस्वीरें' : 'Photos'})
                </Card.Header>
                <Card.Body>                        
                    <GlimpsesImage sgId={sg.sg_id} />
                </Card.Body>
            </Card>
            ))}
            </React.Fragment>
        )}
        </React.Fragment>
    );
}
export default GlimpsesDetails;
const GlimpsesImage = ({sgId}) => 
{
    const [open, setOpen] = React.useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);
    const openLightbox = (index) => {setCurrentIndex(index);setOpen(true);};
    const[isLoading, setLoading] = useState(true);
    const[images,setImages]=useState([]);
    const[videos,setVideos]=useState([]);
    useEffect(()=>
    {
        const GetGlimpsesImage = async () => 
        {
            try 
            {
                const imgArray = [];
                const vidArray = [];
                const response = await fetch(global.config.API_URL+"upload/details/0/"+sgId+"/siteGlimpses");
                const result = await response.json();
                result.forEach(up => {
                    if (up.up_ext === '.mp4') {
                        vidArray.push({src:global.config.uploadPath+up.up_fname+up.up_ext});
                    } else {
                        imgArray.push({src:global.config.uploadPath+up.up_fname+up.up_ext});
                    }
                });
                setVideos(vidArray);
                setImages(imgArray);
                setLoading(false);
                if( global.config.IsPrint === true ) { console.info('GetGlimpsesImage : Result',result); }
            }
            catch (error) 
            {
                console.error('GetGlimpsesImage : Error', error.message);
            }
        };
        GetGlimpsesImage();
    },[sgId])
    return (
        <React.Fragment>
            {isLoading ? ( 
            <Row className='row-cols-1 row-cols-sm-2 row-cols-md-3 g-3 '>
                {[...Array(12)].map((_,index)=>(
                <Col key={index}>
                    <Card className='bg-secondary-subtle border border-3 text-center'>
                        <Placeholder xs={12} style={{height:"200px"}} className="img-fluid" />
                    </Card>
                </Col>
                ))}
            </Row>
            ) : (
                <React.Fragment>
                <Row className='row-cols-1 row-cols-sm-2 row-cols-md-3 g-3 mb-3'>
                {videos.map((up,index)=>( 
                    <Col key={index} >
                        <div className="ratio ratio-16x9 border border-4 rounded overflow-hidden" data-aos="flip-up" data-aos-duration="1000">
                            <video controls>
                                <source src={up.src} type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        </div>                    
                    </Col>
                ))}
                </Row>
                <Row className='row-cols-1 row-cols-sm-2 row-cols-md-3 g-3 '>
                {images.map((up,index)=>( 
                    <Col key={index} >                    
                        <Card className='card-glimpses bg-secondary-subtle text-center border-3 position-relative' onClick={() => openLightbox(index)} style={{ cursor: 'pointer' }}>
                            <Card.Img src={up.src} className='img-fluid' />
                            <div className='action-overlay'><i className="bi bi-zoom-in"></i></div>
                        </Card>
                    </Col>
                ))}
                    <Lightbox open={open} close={() => setOpen(false)} slides={images} index={currentIndex} plugins={[Counter,Fullscreen,Slideshow,Zoom,Thumbnails]} />
                </Row>
                </React.Fragment>
            )}
        </React.Fragment>
    );
}